var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "view-contanier" },
    [
      _c("div", { staticClass: "header" }, [
        _c("div", { staticClass: "tab" }, [
          _c(
            "span",
            {
              staticClass: "tabItem",
              class: { active: _vm.active === -1 },
              on: {
                click: function ($event) {
                  return _vm.changeType(-1)
                },
              },
            },
            [
              _vm._v(
                "全部(" +
                  _vm._s(
                    (_vm.tabNumer?.find((a) => a.type === 0)?.qty || 0) +
                      (_vm.tabNumer?.find((a) => a.type === 4)?.qty || 0)
                  ) +
                  ")"
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "tabItem",
              class: { active: _vm.active === 0 },
              on: {
                click: function ($event) {
                  return _vm.changeType(0)
                },
              },
            },
            [
              _vm._v(
                "处理中(" +
                  _vm._s(_vm.tabNumer?.find((a) => a.type === 0)?.qty || 0) +
                  ")"
              ),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "tabItem",
              class: { active: _vm.active === 4 },
              on: {
                click: function ($event) {
                  return _vm.changeType(4)
                },
              },
            },
            [
              _vm._v(
                "完结(" +
                  _vm._s(_vm.tabNumer?.find((a) => a.type === 4)?.qty || 0) +
                  ")"
              ),
            ]
          ),
        ]),
        _c(
          "div",
          { staticClass: "opt" },
          [
            _c(
              "div",
              { staticClass: "search" },
              [
                _c(
                  "el-popover",
                  {
                    ref: "popover",
                    staticClass: "searchPop",
                    attrs: {
                      placement: "top",
                      title: "批量搜索",
                      trigger: "click",
                      width: "378",
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "close",
                        on: { click: _vm.closeSearchPanel },
                      },
                      [_c("i", { staticClass: "el-icon-close" })]
                    ),
                    _c("base-muti-input", {
                      ref: "baseMutiInput",
                      attrs: { default: _vm.referenceNumber },
                      model: {
                        value: _vm.referenceNumber,
                        callback: function ($$v) {
                          _vm.referenceNumber = $$v
                        },
                        expression: "referenceNumber",
                      },
                    }),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "right",
                          margin: "16px 0 0",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "small" },
                            on: { click: _vm.handleEmpty },
                          },
                          [_vm._v("清空")]
                        ),
                        _c(
                          "div",
                          {
                            staticClass: "sure",
                            on: { mousedown: _vm.handleConfirm },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("el-input", {
                  staticClass: "input-search",
                  attrs: {
                    value: _vm.searchVal,
                    placeholder: "请输入提单号搜索",
                  },
                  on: { focus: _vm.handleFocus },
                }),
                _c(
                  "div",
                  {
                    staticClass: "btn-search",
                    on: { click: _vm.handleConfirm },
                  },
                  [_c("i", { staticClass: "el-icon-search" })]
                ),
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "debounce-click",
                    rawName: "v-debounce-click",
                    value: _vm.batchExport,
                    expression: "batchExport",
                  },
                ],
                staticClass: "import",
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/images/bill/import.png"),
                    alt: "",
                  },
                }),
                _vm._v("导出 "),
              ]
            ),
            _c(
              "BaseFilter",
              {
                attrs: { isActive: _vm.isActive, width: 892 },
                on: { sendFilter: _vm.sendFilter, reset: _vm.reset },
              },
              [
                _c(
                  "div",
                  { staticClass: "filter" },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "form",
                        attrs: {
                          model: _vm.filterList,
                          "label-width": "110px",
                        },
                      },
                      [
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "客户" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "310px" },
                                        attrs: {
                                          filterable: "",
                                          placeholder: "请选择",
                                        },
                                        model: {
                                          value: _vm.filterList.companyId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.filterList,
                                              "companyId",
                                              $$v
                                            )
                                          },
                                          expression: "filterList.companyId",
                                        },
                                      },
                                      _vm._l(
                                        _vm.companyOptions,
                                        function (item) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value,
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "业务员" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "310px" },
                                        attrs: {
                                          filterable: "",
                                          placeholder: "请选择",
                                          multiple: "",
                                        },
                                        model: {
                                          value: _vm.filterList.saleIds,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.filterList,
                                              "saleIds",
                                              $$v
                                            )
                                          },
                                          expression: "filterList.saleIds",
                                        },
                                      },
                                      _vm._l(_vm.userOptions, function (item) {
                                        return _c("el-option", {
                                          key: item.value,
                                          attrs: {
                                            label: item.label,
                                            value: item.value,
                                          },
                                        })
                                      }),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "创建日期" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "310px" },
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        align: "center",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "value-format": "yyyy-MM-dd",
                                        "unlink-panels": "",
                                        "picker-options": _vm.pickerOptions,
                                      },
                                      model: {
                                        value: _vm.filterList.createOn,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterList,
                                            "createOn",
                                            $$v
                                          )
                                        },
                                        expression: "filterList.createOn",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "ETA" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "310px" },
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        align: "center",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "value-format": "yyyy-MM-dd",
                                        "unlink-panels": "",
                                        "picker-options": _vm.pickerOptions,
                                      },
                                      model: {
                                        value: _vm.filterList.eta,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filterList, "eta", $$v)
                                        },
                                        expression: "filterList.eta",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "ETD" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "310px" },
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        align: "center",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "value-format": "yyyy-MM-dd",
                                        "unlink-panels": "",
                                        "picker-options": _vm.pickerOptions,
                                      },
                                      model: {
                                        value: _vm.filterList.etd,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filterList, "etd", $$v)
                                        },
                                        expression: "filterList.etd",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "清关放行时间" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "310px" },
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        align: "center",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "value-format": "yyyy-MM-dd",
                                        "unlink-panels": "",
                                        "picker-options": _vm.pickerOptions,
                                      },
                                      model: {
                                        value: _vm.filterList.releaseDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterList,
                                            "releaseDate",
                                            $$v
                                          )
                                        },
                                        expression: "filterList.releaseDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "卸船日期" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "310px" },
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        align: "center",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "value-format": "yyyy-MM-dd",
                                        "unlink-panels": "",
                                        "picker-options": _vm.pickerOptions,
                                      },
                                      model: {
                                        value: _vm.filterList.dischargeDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterList,
                                            "dischargeDate",
                                            $$v
                                          )
                                        },
                                        expression: "filterList.dischargeDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "到卸货港日期" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "310px" },
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        align: "center",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "value-format": "yyyy-MM-dd",
                                        "unlink-panels": "",
                                        "picker-options": _vm.pickerOptions,
                                      },
                                      model: {
                                        value:
                                          _vm.filterList.dischargeHarborDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterList,
                                            "dischargeHarborDate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "filterList.dischargeHarborDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "仓库" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "310px" },
                                      attrs: { placeholder: "请输入仓库" },
                                      model: {
                                        value: _vm.filterList.code,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.filterList, "code", $$v)
                                        },
                                        expression: "filterList.code",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "还空柜日期" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "310px" },
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        align: "center",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "value-format": "yyyy-MM-dd",
                                        "unlink-panels": "",
                                        "picker-options": _vm.pickerOptions,
                                      },
                                      model: {
                                        value: _vm.filterList.emptyReturnedDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterList,
                                            "emptyReturnedDate",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "filterList.emptyReturnedDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-row",
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 12 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "提柜日期" } },
                                  [
                                    _c("el-date-picker", {
                                      staticStyle: { width: "310px" },
                                      attrs: {
                                        type: "daterange",
                                        "range-separator": "至",
                                        align: "center",
                                        "start-placeholder": "开始日期",
                                        "end-placeholder": "结束日期",
                                        "value-format": "yyyy-MM-dd",
                                        "unlink-panels": "",
                                        "picker-options": _vm.pickerOptions,
                                      },
                                      model: {
                                        value: _vm.filterList.pickUpDate,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.filterList,
                                            "pickUpDate",
                                            $$v
                                          )
                                        },
                                        expression: "filterList.pickUpDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "data" },
        [
          _vm.height !== 0
            ? _c("BaseTable", {
                attrs: {
                  height: _vm.height,
                  tableData: _vm.tableData,
                  pageIndex: _vm.pagerConfig.pageIndex,
                  pageSize: _vm.pagerConfig.pageSize,
                  loading: _vm.loading,
                  isEmptyBorder: true,
                },
                on: {
                  handlePageChange: _vm.handlePageChange,
                  sortChange: _vm.sortChange,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "harborName",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType0" },
                              [_vm._v("始发港/机场")]
                            ),
                            _vm._v(_vm._s(row.scope.originHarborName) + " "),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType1" },
                              [_vm._v("卸货港")]
                            ),
                            _vm._v(_vm._s(row.scope.dischargeHarbor) + " "),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType2" },
                              [_vm._v("目的港/机场")]
                            ),
                            _vm._v(
                              _vm._s(row.scope.destinationHarborName) + " "
                            ),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType3" },
                              [_vm._v("船名/航次")]
                            ),
                            _vm._v(
                              _vm._s(row.scope.vesselName) +
                                "/" +
                                _vm._s(row.scope.voyageNo) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "cargoData",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType0" },
                              [_vm._v("件数")]
                            ),
                            _vm._v(_vm._s(row.scope.qty) + " "),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType1" },
                              [_vm._v("实重")]
                            ),
                            _vm._v(_vm._s(row.scope.weight) + " "),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType2" },
                              [_vm._v("方数")]
                            ),
                            _vm._v(_vm._s(row.scope.square) + " "),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "ETDATD",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType0" },
                              [_vm._v("ETD")]
                            ),
                            _vm._v(
                              _vm._s(_vm._f("dateFilete")(row.scope.etd)) + " "
                            ),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType1" },
                              [_vm._v("ATD")]
                            ),
                            _vm._v(
                              _vm._s(_vm._f("dateFilete")(row.scope.atd)) + " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "ETAATA",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType0" },
                              [_vm._v("ETA")]
                            ),
                            _vm._v(
                              _vm._s(_vm._f("dateTimeFilter")(row.scope.eta)) +
                                " "
                            ),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType1" },
                              [_vm._v("ATA")]
                            ),
                            _vm._v(
                              _vm._s(_vm._f("dateTimeFilter")(row.scope.ata)) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "anDo",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType0" },
                              [_vm._v("AN日期")]
                            ),
                            _vm._v(
                              _vm._s(_vm._f("dateFilete")(row.scope.anDate)) +
                                " "
                            ),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType1" },
                              [_vm._v("DO日期")]
                            ),
                            _vm._v(
                              _vm._s(_vm._f("dateFilete")(row.scope.doDate)) +
                                " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "terminalName",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType0" },
                              [_vm._v("码头")]
                            ),
                            _vm._v(_vm._s(row.scope.terminalName) + " "),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType1" },
                              [_vm._v("卸船日期")]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFilete")(row.scope.dischargeDate)
                              ) + " "
                            ),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType2" },
                              [_vm._v("available日期")]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFilete")(row.scope.availableDate)
                              ) + " "
                            ),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType3" },
                              [_vm._v("LFD日期")]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFilete")(row.scope.lastFreeDate)
                              ) + " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "pickup",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType0" },
                              [_vm._v("预约提柜日期")]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFilete")(
                                  row.scope.reservedPickUpDate
                                )
                              ) + " "
                            ),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType1" },
                              [_vm._v("提柜日期")]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFilete")(row.scope.picPickUpDate)
                              ) + " "
                            ),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType2" },
                              [_vm._v("预约直送日期")]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFilete")(
                                  row.scope.reservedDirectDate
                                )
                              ) + " "
                            ),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType3" },
                              [_vm._v("直送日期")]
                            ),
                            _vm._v(
                              _vm._s(
                                _vm._f("dateFilete")(row.scope.directDate)
                              ) + " "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "deliveryInfo",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType0" },
                              [_vm._v("ISA/预约号")]
                            ),
                            _vm._v(_vm._s(row.scope.isISA ? "是" : "否") + " "),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType1" },
                              [_vm._v("BOL")]
                            ),
                            _vm._v(_vm._s(row.scope.isBOL ? "是" : "否") + " "),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType2" },
                              [_vm._v("POD")]
                            ),
                            _vm._v(_vm._s(row.scope.isPOD ? "是" : "否") + " "),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType3" },
                              [_vm._v("POD日期")]
                            ),
                            _vm._v(
                              _vm._s(_vm._f("dateFilete")(row.scope.podDate)) +
                                " "
                            ),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType4" },
                              [_vm._v("POD时效")]
                            ),
                            _vm._v(_vm._s(row.scope.podPrescription) + " "),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "isLineHold",
                      fn: function (row) {
                        return [
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType0" },
                              [_vm._v("Freight")]
                            ),
                            _vm._v(_vm._s(row.scope.terminalFeeNote) + " "),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType1" },
                              [_vm._v("Customs")]
                            ),
                            _vm._v(_vm._s(row.scope.terminalCustoms) + " "),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType2" },
                              [_vm._v("Terminal hold")]
                            ),
                            _vm._v(_vm._s(row.scope.terminalHoldNote) + " "),
                          ]),
                          _c("p", { staticStyle: { "text-align": "left" } }, [
                            _c(
                              "span",
                              { staticClass: "pickUpType pickUpType3" },
                              [_vm._v("Terminal Fee")]
                            ),
                            _vm._v(_vm._s(row.scope.terminalFeeNote) + " "),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "puNumber",
                      fn: function (row) {
                        return [
                          _c("div", { staticStyle: { display: "flex" } }, [
                            _c("div", { staticStyle: { width: "160px" } }, [
                              _c("p", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "pickUpType",
                                    class: `pickUpType0`,
                                  },
                                  [_vm._v(" PICK UP# ")]
                                ),
                                _vm._v(" " + _vm._s(row.scope.puNo) + " "),
                              ]),
                              _c("p", [
                                _c(
                                  "span",
                                  {
                                    staticClass: "pickUpType",
                                    class: `pickUpType1`,
                                  },
                                  [_vm._v(" PU# 日期 ")]
                                ),
                                _vm._v(" " + _vm._s(row.scope.puDate) + " "),
                              ]),
                            ]),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "code",
                      fn: function (row) {
                        return [
                          _vm._v(" " + _vm._s(row.scope.code) + " "),
                          _c("i", {
                            staticClass: "el-icon-edit",
                            staticStyle: {
                              color: "rgb(18,88,188)",
                              cursor: "pointer",
                            },
                            attrs: { title: "修改仓库" },
                            on: {
                              click: function ($event) {
                                return _vm.editWareHouse(row.scope)
                              },
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "directRemark",
                      fn: function (row) {
                        return [
                          _c(
                            "p",
                            {
                              staticStyle: {
                                "max-width": "80px",
                                display: "inline-block",
                                overflow: "hidden",
                                "vertical-align": "bottom",
                              },
                            },
                            [_vm._v(" " + _vm._s(row.scope.directRemark))]
                          ),
                          _c("i", {
                            staticClass: "el-icon-edit",
                            on: {
                              click: function ($event) {
                                return _vm.editRemark(row.scope)
                              },
                            },
                          }),
                        ]
                      },
                    },
                    {
                      key: "opt",
                      fn: function (row) {
                        return [
                          _c(
                            "el-popover",
                            {
                              ref: `popover${row.scope.id}`,
                              attrs: {
                                placement: "bottom-start",
                                "popper-class": "pop-table-opt",
                                width: "114",
                                trigger: "click",
                              },
                            },
                            [
                              _c("div", { staticClass: "table-opt" }, [
                                _c(
                                  "div",
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "permissson",
                                            rawName: "v-permissson",
                                            value: "update",
                                            expression: "'update'",
                                          },
                                        ],
                                        staticClass: "opt-item",
                                        on: {
                                          click: function ($event) {
                                            return _vm.update(row.scope)
                                          },
                                        },
                                      },
                                      [_vm._v("修改")]
                                    ),
                                    _vm.active === 0
                                      ? _c(
                                          "el-button",
                                          {
                                            staticClass: "opt-item",
                                            on: {
                                              click: function ($event) {
                                                return _vm.finishBill(row.scope)
                                              },
                                            },
                                          },
                                          [_vm._v("完结")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                              _c("img", {
                                attrs: {
                                  slot: "reference",
                                  src: require("@/assets/images/table/opt.png"),
                                },
                                slot: "reference",
                              }),
                            ]
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3302536794
                ),
              })
            : _vm._e(),
        ],
        1
      ),
      _c("UpdateDirectDeliveryDialog", {
        attrs: { dialogVisible: _vm.dialogVisible, rowData: _vm.rowData },
        on: { ok: _vm.ok, cancel: _vm.cancel },
      }),
      _c("TruckDetailDrawer", {
        attrs: {
          drawer: _vm.drawer,
          rowData: _vm.rowData,
          type: 1,
          mblSendWayId: _vm.rowData?.id,
        },
        on: {
          close: function ($event) {
            _vm.drawer = false
          },
        },
      }),
      _c("EditWarehouseDialog", {
        attrs: { dialogVisible: _vm.dialogVisible1, rowData: _vm.rowData },
        on: {
          ok: function ($event) {
            _vm.dialogVisible1 = false
            _vm.getList(_vm.pagerConfig)
          },
          cancel: function ($event) {
            _vm.dialogVisible1 = false
          },
        },
      }),
      _c("UpdateDirectDeliveryRemarkDialog", {
        attrs: { dialogVisible: _vm.dialogVisible2, rowData: _vm.rowData },
        on: {
          ok: function ($event) {
            _vm.dialogVisible2 = false
            _vm.getList(_vm.pagerConfig)
          },
          cancel: function ($event) {
            _vm.dialogVisible2 = false
          },
        },
      }),
      _c("PuDateDialog", {
        attrs: { dialogVisible: _vm.dialogVisible3, rowData: _vm.rowData },
        on: {
          ok: function ($event) {
            _vm.dialogVisible3 = false
            _vm.getList(_vm.pagerConfig)
          },
          cancel: function ($event) {
            _vm.dialogVisible3 = false
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }